import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  wrapper: {
    display: 'flex',
    margin: `0 ${theme.spacing(2)}px`,
    alignItems: 'center',
    alignSelf: 'center',
  },
});

const RadioButtonsGroup = ({ options, handleChange, value, classes }) => {
  
  return (
    <FormControl className={classes.wrapper}>
      <RadioGroup
        value={value}
        onChange={(event) => handleChange(event.target.value)}>
        {options}
      </RadioGroup>
    </FormControl>
  );
};

export default withStyles(styles)(RadioButtonsGroup);